import { useLayoutEffect, useState } from 'react';

export const useTopSlotHeight = () => {
  const [topSlotElement, setTopSlotElement] = useState<HTMLDivElement | null>(null);
  const [topSlotHeight, setTopSlotHeight] = useState(0);

  useLayoutEffect(() => {
    if (!topSlotElement) {
      setTopSlotHeight(0);
      return;
    }

    const measure = () => setTopSlotHeight(topSlotElement.offsetHeight);

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(topSlotElement);

    return () => observer.disconnect();
  }, [topSlotElement]);

  return { topSlotRef: setTopSlotElement, topSlotHeight };
};
